import React from 'react'
import './style.css'
import {InputGroup, FormControl} from 'react-bootstrap'

export default function Input(props) {
    return (
        <InputGroup className={props.cGroup}>
            <FormControl type="text" placeholder={props.placeholder}  />
            <InputGroup.Text>
                <img src="asset/dashboard/icons/Search.svg" alt="search" />
            </InputGroup.Text>
        </InputGroup>
    )
}
